import styled from "styled-components";

export const DesignContainer = styled.div`
  display: flex;
  justify-content: ${({ alignment }) => alignment};
`;
